import { jsx as _jsx } from "react/jsx-runtime";
export const Selector = (props) => {
    const { name, value, onChange } = props;
    const options = [];
    let idx = 1;
    for (const o of props.options) {
        options.push(_jsx("option", { value: o.value, children: o.label }, o.value + '_' + idx++));
    }
    return (_jsx("select", { name: name, value: value, onChange: onChange, children: options }));
};
